export const isBlobUrl = (url: string) => url.startsWith('blob:');